export default __webpack_public_path__ + "88c78c865e5525662e91c53b05d4ac34.png";